/**
 * Labstep
 *
 * @module components/File/Filter/Extension/Select
 * @desc Select filter for extensions
 */

import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { Select as ReactSelect } from 'labstep-web/core/Select';
import type { ReactSelectOption } from 'labstep-web/core/Select/types';
import { fileTypes } from 'labstep-web/models/file.model';
import type React from 'react';
import { placeholder } from './strings';
import type { FileFilterExtensionSelectProps } from './types';

export const FileFilterExtensionSelect: React.FC<
  FileFilterExtensionSelectProps
> = ({ setParams, searchParams }) => {
  return (
    <Modal
      header={'File Type'}
      content={({ toggleModal }) => (
        <ReactSelect
          value={
            searchParams.extension
              ? {
                  value: searchParams.extension,
                  label: searchParams.extension,
                }
              : null
          }
          options={fileTypes.map((key) => ({
            value: key,
            label: key,
          }))}
          isClearable
          onChange={(selectedOption: ReactSelectOption) => {
            setParams({
              extension: selectedOption
                ? selectedOption.value
                : undefined,
            });

            toggleModal();
          }}
          placeholder={placeholder}
        />
      )}
      viewComponent={({ toggleModal }) => (
        <ActionComponent
          type="option"
          icon="file"
          text={'File Type'}
          onClick={toggleModal}
        />
      )}
    />
  );
};
